import * as api from "../../api/index";
import * as endpoints from "../../api/endpoints";
import * as types from "../../api/../mutation-types";

const actions = {
  //SmWarehouses
  getSmWarehouses({ commit }, payload) {
    return api.fetch(endpoints.SM_WAREHOUSES, payload, commit, (response) => {
      commit(types.SET_SM_WAREHOUSES, response.data.data);
      commit("common/" + types.SET_PAGINATION, response.data.pagination, { root: true });
    });
  },
  getSmWarehouse({ commit }, payload) {
    return api.fetch(endpoints.SM_WAREHOUSES + "/" + payload.uuid, payload, commit, (response) => {
      commit(types.SET_SM_WAREHOUSE, response.data);
    });
  },
  createSmWarehouse({ commit }, payload) {
    return api.post(endpoints.SM_WAREHOUSES, payload, commit, (response) => {
      commit(types.SET_SM_WAREHOUSE, response.data);
    });
  },
  updateSmWarehouse({ commit }, payload) {
    return api.put(endpoints.SM_WAREHOUSES + "/" + payload.uuid, payload, commit, (response) => {
      commit(types.SET_SM_WAREHOUSE, response.data);
    });
  },
  deleteSmWarehouse({ commit }, payload) {
    return api.remove(endpoints.SM_WAREHOUSES + "/" + payload.uuid, payload, commit, (response) => {
      commit(types.SET_SM_WAREHOUSE, response.data);
    });
  },
  syncErpLegacyWarehouses({ commit }, payload) {
    return api.post(endpoints.ERP_LEGACY_SYNC_WAREHOUSES, payload ?? {}, commit, (response) => {
      return response;
    });
  },
  getErpLegacyWarehouses({ commit }) {
    return api.fetchFull(endpoints.ERP_LEGACY_WAREHOUSES, {}, commit, (response) => response);
  },
  getErpWarehouseMappings({ commit }) {
    return api.fetchFull(endpoints.ERP_LEGACY_WAREHOUSE_MAPPINGS, {}, commit, (response) => response);
  },
  storeErpWarehouseMapping({ commit }, payload) {
    return api.post(endpoints.ERP_LEGACY_WAREHOUSE_MAPPINGS, payload, commit, (response) => response);
  },
  updateErpWarehouseMapping({ commit }, { id, ...payload }) {
    return api.put(endpoints.ERP_LEGACY_WAREHOUSE_MAPPINGS + '/' + id, payload, commit, (response) => response);
  },
  destroyErpWarehouseMapping({ commit }, id) {
    return api.remove(endpoints.ERP_LEGACY_WAREHOUSE_MAPPINGS + '/' + id, {}, commit, (response) => response);
  },
  getErpIntegrationEnabled({ commit }) {
    return api.fetchFull(
      endpoints.replaceParams(endpoints.GROUP_SETTING, {
        uuid: 'ERP_INTEGRATION',
        code: 'ERP_INTEGRATION_ENABLED',
      }),
      {},
      commit,
      (response) => response
    );
  },
};

export default actions;
